/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getPetById } from "../../utils";
import {
  updatePetContact,
  updatePetStateByOwner,
  resetPetContact,
} from "../../utils";
import PetCard from "./PetCard";
import Notification from "../Notification";
import { getAuth } from "firebase/auth";
import Map from "./Map";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Socials from "../buttons/Socials";
import { Link } from "react-router-dom";
import {
  faDownload,
  faPenToSquare,
  faLink,
  faX,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import {
  incrementNotifications,
  decrementNotifications,
  updatePet,
} from "../../features/userNotifications/notificationSlice";
import { useSelector } from "react-redux";
import domtoimage from "dom-to-image";
import ToolTips from "../ToolTips";
import { ConfirmStateChangeModal } from "../Modal";

const PetDetails = () => {
  let endState = 2;
  const auth = getAuth();
  const { id } = useParams();
  const [pet, setPet] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentUser = auth.currentUser;
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState(null);
  const [ownerPet, setOwnerPet] = useState(false);
  const [razaName, setRazaName] = useState("");
  const [colorName, setColorName] = useState("");
  const [estadoName, setEstadoName] = useState("");
  const [sexoName, setSexoName] = useState("");
  const [tamanoName, setTamanoName] = useState("");
  const [textTag, setTextTag] = useState("");
  const [modal, setModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const petFormDataState = useSelector((state) => state.compartirMascota);
  const dispatch = useDispatch();

  const tagSearch = {
    1: ["Su familia lo busca", "#f24a4a"],
    2: ["Proceso finalizado", "#f2c200"],
    3: ["Encontrado", "#76a9d2"],
    4: ["Busca una familia", "#7acf84"],
  };

  useEffect(() => {
    const dataView = () => {
      if (pet.length > 0) {
        pet[0].estado === "Recuperado"
          ? setTextTag(tagSearch[2])
          : setTextTag(tagSearch[pet[0].estado]);
        const raza = petFormDataState.raza.find((r) => r.id === pet[0].raza);
        const color = petFormDataState.color.find((r) => r.id === pet[0].color);
        const estado = petFormDataState.estado.find(
          (r) => r.id === pet[0].estado
        );
        const sexo = petFormDataState.sexo.find((r) => r.id === pet[0].sexo);
        const tamano = petFormDataState.tamano.find(
          (r) => r.id === pet[0].tamano
        );

        if (estado) {
          switch (estado.nombre) {
            case "Buscando":
              setEstadoName("Espera volver a su hogar");
              break;
            case "Adopcion":
              setEstadoName("En adopción");
              break;
            case "Encontrado":
              setEstadoName("Volvió con su familia");
              break;
            default:
              setEstadoName(estado.nombre);
          }
        } else {
          setEstadoName(pet[0].estado);
        }

        raza ? setRazaName(raza.nombre) : setRazaName(pet[0].raza);
        color ? setColorName(color.nombre) : setColorName(pet[0].color);
        sexo ? setSexoName(sexo.nombre) : setSexoName(pet[0].sexo);
        tamano ? setTamanoName(tamano.nombre) : setTamanoName(pet[0].tamano);
      }
    };

    dataView();
  }, [pet, petFormDataState]);

  useEffect(() => {
    const fetchPet = async () => {
      try {
        const petData = await getPetById(id);
        setPet(petData);
      } catch (error) {
        console.error("Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPet();
  }, [id]);

  useEffect(() => {
    const petStateOwnerEdit = () => {
      if (pet && Array.isArray(pet) && pet.length > 0) {
        if (currentUser && currentUser.uid === pet[0].userId) {
          setOwnerPet(true);
        }
      }
    };
    petStateOwnerEdit();
  }, [currentUser, pet, id]);

  const editPetState = async () => {
    try {
      await updatePetStateByOwner(id, endState);
      dispatch(
        updatePet({
          id,
          updatedData: { estado: endState, en_contacto: false },
        })
      );
      dispatch(decrementNotifications());
      setPet((prevPet) => {
        if (Array.isArray(prevPet) && prevPet.length > 0) {
          return [{ ...prevPet[0], estado: endState, en_contacto: false }];
        }
        return prevPet;
      });
      setShowConfirmModal(false);
      setNotification({
        type: "success",
        message: "¡Felicidades! La mascota ha sido marcada como recuperada.",
      });
      setVisible(true);
    } catch (error) {
      console.error(error);
      setNotification({
        type: "error",
        message: "Hubo un error al actualizar. Por favor inténtalo de nuevo.",
      });
      setVisible(true);
    }
  };

  const handleOpenConfirmModal = () => {
    setShowConfirmModal(true);
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const elementRef = useRef(null);
  const [downloadMode, setDownloadMode] = useState(false);

  const handleDownload = () => {
    setDownloadMode(true);

    setTimeout(() => {
      const node = elementRef.current;

      const scale = 3;
      const width = node.offsetWidth;
      const height = node.offsetHeight;

      domtoimage
        .toPng(node, {
          width: width * scale,
          height: height * scale,
          style: {
            transform: `scale(${scale})`,
            transformOrigin: "top left",
            width: `${width}px`,
            height: `${height}px`,
          },
        })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = "comparte-tu-mascota.png";
          link.href = dataUrl;
          link.click();
        })
        .catch((error) => {
          console.error("Error al generar la imagen:", error);
        })
        .finally(() => {
          setDownloadMode(false);
        });
    });
  };

  const copy = () => {
    var a = document.createElement("input");
    a.setAttribute("value", location.pathname);
    document.body.appendChild(a);
    a.select();
    document.execCommand("copy");
    document.body.removeChild(a);

    alert("Copiado al portapapeles");
  };

  const handleResetContact = async () => {
    await resetPetContact(pet[0].id);
    setPet([{ ...pet[0], en_contacto: false }]);
  };

  const updatePetContactInfo = async () => {
    try {
      if (currentUser) {
        await updatePetContact(pet[0].id, currentUser.uid);
        dispatch(incrementNotifications());
        setNotification({
          type: "success",
          message: "Se envió una notificación al propietario correctamente.",
        });
        setPet([
          {
            ...pet[0],
            en_contacto: true,
            contact_users: [...(pet[0].contact_users || []), currentUser.uid],
          },
        ]);
      }
    } catch (error) {
      console.error(error);
      setNotification({
        type: "error",
        message: "Hubo un error al actualizar. Por favor inténtalo de nuevo.",
      });
    }
    setVisible(true);
  };

  const basePath = "/mascota/";
  const identifier = location.pathname.startsWith(basePath)
    ? location.pathname.substring(basePath.length)
    : location.pathname;

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <main className="flex flex-col relative min-h-screen pt-6 bg-orange-50">
      {modal ? (
        <div className="modal-container z-20 bg-black fixed top-0 left-0 w-[100%] h-[100%] grid place-items-center bg-opacity-70">
          <div className="modal-body flex w-full h-full rounded-md relative items-center justify-center">
            <button
              className="absolute top-4 right-4 w-[40px] h-[40px] m-8"
              onClick={toggleModal}
            >
              <FontAwesomeIcon icon={faX} className="text-white text-3xl" />
            </button>
            <div
              className="bg-no-repeat bg-center bg-contain w-[95%] h-[95%]"
              style={{ backgroundImage: `url(${pet[0].foto})` }}
            ></div>
          </div>
        </div>
      ) : (
        <></>
      )}

      <ConfirmStateChangeModal
        show={showConfirmModal}
        onClose={handleCloseConfirmModal}
        onConfirm={editPetState}
        petName={pet[0]?.nombre || "la mascota"}
      />

      <div className="h-full w-full px-[15dvw] flex flex-col gap-2 items-center sm:px-4">
        {loading ? (
          <></>
        ) : (
          <div className="h-full flex flex-col w-full pb-10">
            <div className="flex flex-col h-full gap-3 items-center">
              {ownerPet ? (
                <>
                  <div className="pb-10 z-10">
                    <p className="p-2 h-[6dvh] pd:text-5xl text-4xl uppercase text-center font-main text-white z-10 font-semibold">
                      Tu subiste esta mascota
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div className="pb-10 z-10">
                    <p
                      className={`${pet[0].estado} text-4xl uppercase text-center font-main text-white z-10 font-semibold`}
                    >
                      {estadoName}
                    </p>
                  </div>
                </>
              )}

              <div className="flex flex-col items-center w-full pd:min-w-[0px] lg:min-w-[888px] bg-white z-10 p-2 sm:p-4 sm:w-auto rounded-lg">
                <div className="w-full h-full flex pd:flex-col gap-4">
                  <section className="w-fit pd:w-full pd:flex-col flex h-full bg-white justify-center items-center gap-3 mb-4 lg:mb-0 z-10">
                    <div className="rounded-xl overflow-hidden">
                      <div ref={elementRef}>
                        <PetCard
                          ref={elementRef}
                          key={id}
                          data={pet[0]}
                          qr={true}
                          imageClick={toggleModal}
                        />
                      </div>
                    </div>

                    <div className="flex flex-col w-[50px] h-[45px] pd:justify-center pd:flex-row gap-2 items-center text-justify sm:w-auto">
                      <Socials
                        shareUrl={window.location.href}
                        estado={pet[0].estado}
                      />

                      <div>
                        <ToolTips text="Copiar url">
                          <button
                            className="w-[50px] h-[45px] px-4 py-2 flex justify-center items-center bg-white border rounded-md hover:bg-secondary hover:text-white"
                            onClick={copy}
                          >
                            <FontAwesomeIcon icon={faLink} />
                          </button>
                        </ToolTips>
                      </div>

                      <ToolTips text="Descargar imagen" position="bottom">
                        <button
                          onClick={handleDownload}
                          className="w-[50px] h-[45px] px-4 py-2 bg-white border rounded-md hover:bg-secondary hover:text-white"
                        >
                          <FontAwesomeIcon icon={faDownload} />
                        </button>
                      </ToolTips>
                      {currentUser !== null &&
                        currentUser.uid === pet[0]?.userId &&
                        pet[0]?.estado !== 2 && (
                          <div>
                            <Link to={`/editar/${identifier}`}>
                              <button
                                className="w-[50px] h-[45px] px-4 py-2 bg-white border rounded-md hover:bg-secondary hover:text-white"
                                aria-label="Editar mascota"
                              >
                                <FontAwesomeIcon icon={faPenToSquare} />
                              </button>
                            </Link>
                          </div>
                        )}
                    </div>
                  </section>

                  <section className="flex flex-col gap-2 h-fill pd:px-6 z-10 w-full">
                    <div className="flex gap-3 sm:gap-8">
                      <h1 className="font-main font-semibold text-5xl max-w-72">
                        {pet[0].nombre}
                      </h1>
                      <div className="flex flex-col pd:flex-row w-full justify-end items-end">
                        {textTag && (
                          <div
                            className="w-fit p-2 h-[45px] text-center flex items-center justify-center rounded-lg"
                            style={{ backgroundColor: textTag[1] }}
                          >
                            <h2 className="font-main text-regular uppercase text-white">
                              {textTag[0]}
                            </h2>
                          </div>
                        )}
                      </div>
                    </div>

                    <p className="font-main font-medium text-3xl">{razaName}</p>
                    <hr />
                    <div className="flex flex-col items-center">
                      <ul className="flex gap-10 py-2 pl-8 list-disc justify-start sm:flex-wrap sm:justify-center">
                        <li className=" font-main font-regular text-xl list-disc">
                          {sexoName}
                        </li>
                        <li className=" font-main font-regular text-xl list-disc">
                          {tamanoName}
                        </li>
                        <li className=" font-main font-regular text-xl list-disc">
                          {colorName}
                        </li>
                        <li className="font-main font-regular text-xl list-disc">
                          {pet[0].edad} años
                        </li>
                      </ul>
                    </div>
                    <hr />
                    <div className="w-full h-full">
                      <p className="font-main text-lg">{pet[0].descripcion}</p>
                    </div>

                    <div className="z-10 h-full flex flex-col items-center">
                      {pet[0].estado === "Recuperado" ||
                      pet[0].estado === 2 ? null : ownerPet ? (
                        <div className="flex gap-2">
                          <button
                            onClick={handleOpenConfirmModal}
                            className="py-3 px-6 rounded h-fit w-fit font-main  text-lg uppercase shadow-lg text-white bg-secondary hover:bg-orange-700"
                          >
                            Ya encontró su hogar!
                          </button>
                          {pet[0].en_contacto === true && (
                            <button
                              onClick={handleResetContact}
                              className="py-3 px-6 rounded h-fit w-fit font-main  text-lg uppercase shadow-lg text-white bg-gray-400 hover:bg-gray-600"
                            >
                              No se han contactado
                            </button>
                          )}
                        </div>
                      ) : (
                        <div className="w-full flex flex-col items-center">
                          <p className="font-main text-sm text-gray-500 mb-4">
                            Haz <strong>click</strong> debajo para contactarte y
                            notificar a la persona que encontraste su amigo
                          </p>
                          <div className="flex flex-row gap-3 items-center">
                            {currentUser && (
                              <ToolTips text="Envía notificación a quien publicó la mascota">
                                <button
                                  className="p-2 bg-secondary w-[15vw] rounded font-main text-2xl  text-white hover:bg-orange-700 disabled:bg-slate-50 disabled:text-slate-300 disabled:shadow-none sm:w-auto"
                                  onClick={updatePetContactInfo}
                                  disabled={pet[0].contact_users?.includes(
                                    currentUser?.uid
                                  )}
                                >
                                  {pet[0].estado === 4
                                    ? "Quiero adoptarlo"
                                    : pet[0].estado === 1
                                    ? "¡Lo encontré!"
                                    : "¡Es mi mascota!"}
                                </button>
                              </ToolTips>
                            )}
                            {!currentUser && pet[0].contacto && (
                              <a
                                href={`tel:${pet[0].contacto}`}
                                className="py-3 px-6 flex gap-2 justify-center items-center rounded h-fit w-fit font-main  text-lg uppercase shadow-lg text-white bg-green-600 hover:bg-green-700"
                                style={{ textDecoration: "none" }}
                              >
                                <FontAwesomeIcon icon={faPhone} />
                                Llamar
                              </a>
                            )}

                            {currentUser &&
                              pet[0].contact_users?.includes(
                                currentUser?.uid
                              ) &&
                              pet[0].contacto && (
                                <a
                                  href={`tel:${pet[0].contacto}`}
                                  className="py-3 px-6 flex gap-2 justify-center items-center rounded h-fit w-fit font-main  text-lg uppercase shadow-lg text-white bg-green-600 hover:bg-green-700"
                                  style={{ textDecoration: "none" }}
                                >
                                  <FontAwesomeIcon icon={faPhone} />
                                  Llamar
                                </a>
                              )}
                          </div>
                        </div>
                      )}
                    </div>
                    <article>
                      <p className="font-main pd:hidden text-sm text-end">
                        {pet[0].fecha_publi}
                      </p>
                    </article>
                  </section>
                </div>
              </div>

              <div className="flex w-full h-full bg-white items-center z-10">
                <section className="w-full h-full flex flex-col gap-5 p-4 text-center transition-all duration-[0.8s] ease-in-out">
                  <label className="text-3xl font-semibold font-main ">
                    Último lugar visto
                  </label>
                  <Map
                    lat={pet[0].lat}
                    lng={pet[0].lng}
                    petDet={true}
                    zoom={17}
                    height={"58dvh"}
                  />
                </section>
              </div>
            </div>
          </div>
        )}
      </div>

      {notification && (
        <Notification
          type={notification?.type}
          message={notification?.message}
        />
      )}

      <div className="w-screen absolute -top-[100px] left-0 overflow-hidden">
        <svg
          width="100%"
          height="100%"
          id="svg"
          viewBox="0 0 1440 490"
          xmlns="http://www.w3.org/2000/svg"
          className="transition duration-300 ease-in-out delay-150 sm:w-[270%]"
        >
          <path
            d="M 0,500 L 0,93 C 56.27435897435893,109.58461538461539 112.54871794871787,126.16923076923078 203,127 C 293.45128205128213,127.83076923076922 418.0794871794873,112.9076923076923 500,99 C 581.9205128205127,85.0923076923077 621.1333333333333,72.2 684,63 C 746.8666666666667,53.8 833.3871794871797,48.2923076923077 927,58 C 1020.6128205128203,67.7076923076923 1121.3179487179486,92.63076923076922 1208,101 C 1294.6820512820514,109.36923076923078 1367.3410256410257,101.1846153846154 1440,93 L 1440,500 L 0,500 Z"
            stroke="none"
            strokeWidth="0"
            fill="#dc5d00"
            fillOpacity="0.4"
            className="transition-all duration-300 ease-in-out delay-150 path-0"
            transform="rotate(-180 720 250)"
          ></path>
          <path
            d="M 0,500 L 0,218 C 70.46923076923076,227.3230769230769 140.93846153846152,236.64615384615382 226,230 C 311.0615384615385,223.35384615384618 410.71538461538466,200.73846153846156 488,203 C 565.2846153846153,205.26153846153844 620.1999999999999,232.4 694,228 C 767.8000000000001,223.6 860.4846153846156,187.66153846153847 954,181 C 1047.5153846153844,174.33846153846153 1141.8615384615382,196.95384615384614 1223,208 C 1304.1384615384618,219.04615384615386 1372.069230769231,218.52307692307693 1440,218 L 1440,500 L 0,500 Z"
            stroke="none"
            strokeWidth="0"
            fill="#dc5d00"
            fillOpacity="0.53"
            className="transition-all duration-300 ease-in-out delay-150 path-1"
            transform="rotate(-180 720 250)"
          ></path>
          <path
            d="M 0,500 L 0,343 C 73.82820512820513,328.35128205128206 147.65641025641025,313.70256410256417 218,327 C 288.34358974358975,340.29743589743583 355.2025641025641,381.5410256410256 446,388 C 536.7974358974359,394.4589743589744 651.5333333333332,366.1333333333334 748,360 C 844.4666666666668,353.8666666666666 922.6641025641027,369.92564102564097 1001,363 C 1079.3358974358973,356.07435897435903 1157.8102564102564,326.1641025641026 1231,319 C 1304.1897435897436,311.8358974358974 1372.0948717948718,327.41794871794866 1440,343 L 1440,500 L 0,500 Z"
            stroke="none"
            strokeWidth="0"
            fill="#dc5d00"
            fillOpacity="1"
            className="transition-all duration-300 ease-in-out delay-150 path-2"
            transform="rotate(-180 720 250)"
          ></path>
        </svg>
      </div>
    </main>
  );
};

export default PetDetails;
